<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <cashback-job-log-table></cashback-job-log-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import cashbackJobLogTable from './CashbackJobLogTable'

  export default {
    name: 'CashbackJobLogTable',
    components: {cashbackJobLogTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/cashbackJobLog/CashbackJobLog.vue